import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import { connectLocation } from './LocationConnectors';
import LocationModalController from './Popup/Modal';
import { isLocaleMatch } from './locales';

export const CrossingLocale = connectLocation(({ locale, userLocale }) => {
  const mismatched = !isLocaleMatch(locale, userLocale);

  return <LocationModalController mismatched={mismatched} isSwitcher={false} postalRequired showZip showLocale />;
});

export default () => {
  const store = ReactOnRails.getStore('Store');

  return (
    <Provider store={store}>
      <CrossingLocale />
    </Provider>
  );
};
